<template>
  <div class="product" @click="$tools.showGoodInBlank(good.id)" :style="{'--size': size}">
    <el-image class="product-cover" fit="contain" :src="good.photos">
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
    <div class="product-sales">
      <div class="price">{{ (good.price || good.marketprice) | decimal }}</div>
      <div class="saleCount">{{ good.saleNum || 0 }}人付款</div>
    </div>
    <div class="product-name">{{ good.name }}</div>
    <div :title="good.merchantName" class="product-store" @click.stop="$router.push(`/shopStore?storeId=${good.mid}`)">
      <i class="el-icon-guide"></i>
      <span>{{ good.merchantName }}</span>
    </div>
    <div class="address">
      <i class="el-icon-location-outline"></i>
      <span>{{good.merchantAreaName}}</span></div>
  </div>
</template>

<script>
import { addShoppingCart } from '@/api/xunyou';
export default {
  name: "good-card",
  props: {
    size: {
      type: String,
      default: '220px'
    },
    good: {
      type: Object,
      default: () => {}
    }
  },
  created() {
  },
  methods: {
    // 加入购物车
    addCart() {
      this.$tools.isLogin(() => {
        if (this.good.status === 1 && this.good.approvalStatus === 1) {
          const params = {
            cid: this.good.id,
            uid: this.$store.state.userInfo.userId,
            number: 1,
            bxysid: 0,
          };
          addShoppingCart(params).then((res) => {
            console.log("加入购物车结果", res);
            if (res.code === 0) {
              this.successTips();
              this.$store.dispatch('getCartList');
            }
          }).catch((err) => {
            this.$message.error("添加购物车失败，请稍后再试！");
          });
        } else {
          this.$message.error('暂时缺货')
        }
      });
    },
    successTips() {
      this.$confirm(`商品<strong style="color: #f43434;margin: 0 5px;">[${this.good.name}]</strong>加入购物车成功！`,
        '加入成功', {
        confirmButtonText: '去购物车结算',
        cancelButtonText: '继续购物',
        type: 'success',
        center: true,
        customClass: 'addCartSuccess',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$router.push('/shoppingcart');
      }).catch(() => {});
    }
  }
}
</script>

<style scoped lang="less">
.product{
  display: inline-block;
  box-shadow: 0 0 8px 2px rgba(240, 240, 240, 0.5);
  padding: 10px;
  border-radius: 3px;
  background-color: #fff;
  box-sizing: border-box;
  cursor: pointer;
  transition: box-shadow 0.3s ease-out;
  &:hover,&:focus{
    box-shadow: 0 0 10px 5px rgba(210, 210, 210, 0.6);
  }
  .product-cover{
    width: var(--size);
    height: var(--size);
    background-color: #F5F5F5;
    border-radius: 5px;
  }
  .product-name{
    margin: 5px 0;
    width: var(--size);
    height: 36px;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .product-sales{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #888888;
    .price{
      &:before{
        content: '￥';
        font-size: 12px;
        font-weight: normal;
      }
      font-size: 16px;
      color: var(--main-theme-color);
      font-weight: bold;
    }
  }
  .product-store{
    max-width:var(--size);
    color: #888888;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .el-icon-guide{
      font-size: 14px;
      color: #ff5722;
      vertical-align: middle;
    }
    &:hover{
      color: #ff5722;
    }
  }
  .address{
    max-width:var(--size);
    color: #999999;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/good-card.vue